import { useTranslation } from "react-i18next";

import PageLoadError from "components/lib/PageLoadError";

const IdeaNoUser = () => {
  const { t } = useTranslation();
  return <PageLoadError title={t("ideas.errorNoUser")} />;
};

export default IdeaNoUser;
